module.exports = __webpack_public_path__ + "static/media/comandorecompensa.519a651d.png";